export class Roles {
	static Administrator = '090ee690-a242-4696-9a7d-5944d00da2ed';
	static User = 'b3ba8cf8-1ac0-47ce-ae88-cef96a9efa48';
}



// WEBPACK FOOTER //
// ./src/app/guards/roles.ts